function addUpsellToCart(event) {
    event.preventDefault();
    
    event.target.querySelector('.loading__spinner').classList.remove('modal-upsell-wrapper--hidden');
    event.target.querySelector('.modal-upsell__add-btn').setAttribute('aria-disabled', true);
    event.target.querySelector('.modal-upsell__add-btn').setAttribute('disabled', true);

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(event.target);
    formData.append('quantity', 1);

    if (cart) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
    }
    
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
            if (response.status === 422) {
                if (cart) alert(response.description);
                return;
            }
            cart.renderContents(response);
        }).catch((error) => {
            console.error('Error:', error);
        }).finally(() => {
            sessionStorage.setItem(window.upsellModal.productHandle + '-is-upsell-modal-shown', true);
            if (cart) {
                event.target.querySelector('.loading__spinner').classList.remove('modal-upsell-wrapper--hidden');
                event.target.querySelector('.modal-upsell__add-btn').setAttribute('aria-disabled', false);
                event.target.querySelector('.modal-upsell__add-btn').removeAttribute('disabled');

                if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                const modal = document.getElementById('modal-upsell-wrapper');
                if (modal) modal.classList.add('modal-upsell-wrapper--hidden');
                document.dispatchEvent(new CustomEvent('cart:updated'));
                cart.open();
            }
        });
}

function closeUpsellModal() {
    sessionStorage.setItem(window.upsellModal.productHandle + '-is-upsell-modal-shown', true);

    const modal = document.getElementById('modal-upsell-wrapper');
    if (modal) modal.classList.add('modal-upsell-wrapper--hidden');

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart) cart.open();
}

document.querySelectorAll('.modal-upsell__options-selector').forEach(el => {
    el.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (!el.classList.contains('extended') && document.querySelector('.modal-upsell__options-selector.extended')) {
            document.querySelector('.modal-upsell__options-selector.extended').classList.remove('extended');
        }
        el.classList.toggle('extended');
    })
})

document.addEventListener('click', function (e) {
    if(!document.querySelector('.modal-upsell__options-selector')) return;

    if (!e.target.classList.contains('.modal-upsell__options-selector') || !e.target.closest('.modal-upsell__options-selector')) {
        document.querySelector('.modal-upsell__options-selector').classList.remove('extended');
    }
})

document.querySelectorAll('.modal-upsell__option > span').forEach(option => {
    option.addEventListener('click', function () {
        const selectedVariant = window.upsellModal.upsellItems.find(variant => variant.id == option.dataset.variantId);

        const modalUpsell = document.querySelector('.modal-upsell');
        const formVariantIdInput = modalUpsell.querySelector('input[name="id"]');
        const upsellItemImg = modalUpsell.querySelector('.modal-upsell__image');
        
        formVariantIdInput.value = selectedVariant.id;
        upsellItemImg.src = selectedVariant.featured_image.src;
        this.closest('.modal-upsell__options-selector').querySelector('label').innerHTML = this.innerHTML;
    })
})